import { render, staticRenderFns } from "./Arrows.vue?vue&type=template&id=704c87e3&lang=pug&"
import script from "./Arrows.vue?vue&type=script&lang=ts&"
export * from "./Arrows.vue?vue&type=script&lang=ts&"
import style0 from "./Arrows.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports